import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, ChatMessageSeparator } from "pcln-design-system";
import react, { useContext } from "react";
import styled_components from "styled-components";
import { BlockingInputComponent } from "./BlockingInputComponent.js";
import { ButtonChipsAction } from "./components/ButtonChipsAction/ButtonChipsAction.js";
import CalendarComponent from "./components/CalendarComponent/CalendarComponent.js";
import DisplayFeedbackMarker from "./components/DisplayFeedbackMarker/DisplayFeedbackMarker.js";
import ChatMessageErrorBoundary from "./components/ErrorBoundary/ChatMessageErrorBoundary.js";
import { flightRateOptionsManager } from "./components/FlightCompnents/flightRateOptionsManager.js";
import HandleSetiActions from "./components/HandleSetiActions.js";
import { ClientMarkdownParsingComponent } from "./components/MarkdownComponent/ClientMarkdownParsingComponent.js";
import { rentalCarRateOptionsManager } from "./components/RentalCarComponent/rentalCarRateOptionsManager.js";
import ShowCancelConsequencesMarker from "./components/ShowCancelConsequencesMarker/ShowCancelConsequencesMarker.js";
import SignOutActions from "./components/SignOutActions/SignOutActions.js";
import TripProtectionMarker from "./components/TripProtectionMarker/TripProtectionMarker.js";
import Trips from "./components/Trips/Trips.js";
import { ChatbotDataContext } from "./context/ChatbotDataContext.js";
import { HotelDetailCardsMessage } from "./HotelComponent/HotelDetailCard.js";
import { hotelRoomsOptionsManager } from "./HotelComponent/HotelRoomsOptions/hotelRoomsOptionsManager.js";
import { QuickActions } from "./QuickActions.js";
import { QuickActionsChips } from "./QuickActionsChips.js";
import { ScrollIntoView } from "./ScrollIntoView.js";
import { TravelBotChatSingleDialogGeneric } from "./TravelBotChatSingleDialogGeneric.js";
const DisappearingGradientBox = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "ChatMessagesCollections__DisappearingGradientBox"
})([
    "position:relative;&::before{content:'';position:absolute;top:0;left:0;width:16px;height:",
    ";background:linear-gradient(to left,rgba(255,255,255,0),rgba(255,255,255,1));pointer-events:none;z-index:1000;opacity:",
    ";}&::after{content:'';position:absolute;top:0;right:0;width:16px;height:",
    ";background:linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,1));pointer-events:none;z-index:1000;opacity:",
    ";}"
], ({ isLastMessage })=>isLastMessage ? '79px' : '0px', ({ showStartGradient })=>showStartGradient ? 1 : 0, ({ isLastMessage })=>isLastMessage ? '79px' : '0px', ({ showEndGradient })=>showEndGradient ? 1 : 0);
const ChatMessagesList = ({ chatMessages, markerComponents, isLoading, debugMode, setIsDisablingInputValue, setChatMessages, submitMessages, submitChatMessageInMarkerComponent, submitQuickActionMessage, isShowMoreListingCards, isStandalone, messagesEndRef, clearActionsData, isMobile })=>{
    const chatmessageCount = chatMessages.length - 1;
    const [showQuickActionStartGradient, setShowQuickActionStartGradient] = react.useState(false);
    const [showQuickActionEndGradient, setShowQuickActionEndGradient] = react.useState(true);
    const { setiValues } = useContext(ChatbotDataContext);
    const handleQuickActionScroll = function(e) {
        const element = e.currentTarget;
        const isScrolledToBeginning = 0 === element.scrollLeft;
        const isScrolledToEnd = Math.abs(element.scrollWidth - element.clientWidth - element.scrollLeft) < 1;
        setShowQuickActionStartGradient(!isScrolledToBeginning);
        setShowQuickActionEndGradient(!isScrolledToEnd);
    };
    hotelRoomsOptionsManager.setHotelRooms(chatMessages);
    flightRateOptionsManager.setFlightRates(chatMessages);
    rentalCarRateOptionsManager.setRentalCarRates(chatMessages);
    return /*#__PURE__*/ jsxs("div", {
        className: `mb-4 flex flex-col ${setiValues?.shouldEnablePortalUpdates ? 'gap-8 md:gap-6' : 'gap-6'}`,
        children: [
            chatMessages.map((m, i)=>{
                const isLastMessage = chatMessages.length - 1 === i;
                const hasOtherMessageHandler = (m, chatMessage)=>{
                    const mappedChatMessage = chatMessage.map((result)=>JSON.stringify(result));
                    const index = mappedChatMessage.indexOf(JSON.stringify(m));
                    return chatMessage.length - 1 > index;
                };
                if (markerComponents[m?.displayComponentName]) {
                    const Marker = markerComponents[m.displayComponentName];
                    const markerComponentProps = m?.markerComponentProps || {};
                    const markerProps = {
                        ...markerComponentProps,
                        message: m,
                        isLoading,
                        chatMessages,
                        setIsDisablingInputValue,
                        setChatMessages,
                        submitMessages,
                        clearActionsData
                    };
                    return /*#__PURE__*/ jsx(react.Fragment, {
                        children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                            compnentName: m.displayComponentName,
                            children: /*#__PURE__*/ jsx(Marker, {
                                ...markerProps
                            })
                        })
                    }, `chat-msg-host-app-marker-${i}`);
                }
                if (m?.displayComponentName === 'SEPARATOR_COMPONENT') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(Box, {
                        mb: 4,
                        children: /*#__PURE__*/ jsx(ChatMessageSeparator, {})
                    })
                }, `chat-msg-content-separator-${i}`);
                if ('chatContentSeparator' === m.role) {
                    const content = m.content;
                    return /*#__PURE__*/ jsx(ScrollIntoView, {
                        children: /*#__PURE__*/ jsx(Box, {
                            mb: 4,
                            children: /*#__PURE__*/ jsx(ChatMessageSeparator, {
                                message: content
                            })
                        })
                    }, `chat-msg-content-separator-${m.key}-${i}`);
                }
                if (m?.role && m?.content) return /*#__PURE__*/ jsx(ScrollIntoView, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "TravelBotChatSingleDialogGeneric",
                        children: /*#__PURE__*/ jsx(TravelBotChatSingleDialogGeneric, {
                            message: m,
                            isLastMessage: isLastMessage
                        })
                    })
                }, `chat-msg-generic-message-${i}`);
                if (m?.displayComponentName === 'INLINE_METADATA_MARKER') return /*#__PURE__*/ jsx("div", {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "TextWithInlineMetadataComponent",
                        children: /*#__PURE__*/ jsx(ClientMarkdownParsingComponent, {
                            message: m,
                            ...m?.markerComponentProps,
                            isMobile: isMobile,
                            isLastMessage: isLastMessage,
                            submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent
                        })
                    })
                }, `chat-msg-metadata-marker${i}`);
                if (m?.displayComponentName === 'FIRE_SETI') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        children: /*#__PURE__*/ jsx(HandleSetiActions, {
                            setiValues: m?.markerComponentProps?.setiValues
                        })
                    })
                }, `chat-msg-seit-action-message-${i}`);
                if (m?.displayComponentName === 'QUICK_ACTIONS') return /*#__PURE__*/ jsx(DisappearingGradientBox, {
                    showStartGradient: showQuickActionStartGradient,
                    showEndGradient: showQuickActionEndGradient,
                    isLastMessage: isLastMessage,
                    children: /*#__PURE__*/ jsx(ScrollIntoView, {
                        children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                            children: /*#__PURE__*/ jsx(QuickActions, {
                                isStandalone: isStandalone,
                                isSingleLine: true,
                                quickActions: m?.markerComponentProps?.quickActions,
                                hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                                submitQuickActionMessage: submitQuickActionMessage,
                                isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i,
                                onScroll: handleQuickActionScroll
                            })
                        })
                    })
                }, `chat-msg-quick-actions-${i}`);
                if (m?.displayComponentName === 'QUICK_ACTIONS_CHIPS') return /*#__PURE__*/ jsx(ScrollIntoView, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        children: /*#__PURE__*/ jsx(QuickActionsChips, {
                            quickActions: m?.markerComponentProps?.quickActions,
                            hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                            submitQuickActionMessage: submitQuickActionMessage,
                            isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i
                        })
                    })
                }, `chat-msg-quick-chips-${i}`);
                if (m?.displayComponentName === 'BUTTON_CHIPS_ACTION') return /*#__PURE__*/ jsx(ScrollIntoView, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        children: /*#__PURE__*/ jsx(ButtonChipsAction, {
                            submitButtonChipActionMessage: submitQuickActionMessage,
                            hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                            buttonChipsActions: m?.markerComponentProps?.quickActions,
                            isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i
                        })
                    })
                }, `chat-msg-button-chips-actions-${i}`);
                if (m?.displayComponentName === 'SESSION_INITIALIZED') return null;
                if (m?.displayComponentName === 'HOTEL_CARDS_MARKER') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "HotelDetailCardsMessage",
                        children: /*#__PURE__*/ jsx(HotelDetailCardsMessage, {
                            ...m?.markerComponentProps,
                            date: m.date,
                            setChatMessages: setChatMessages,
                            isShowMoreListingCards: isShowMoreListingCards,
                            submitMessages: submitChatMessageInMarkerComponent
                        })
                    })
                }, `chat-msg-hotel-cards-marker-${i}`);
                if (m?.displayComponentName === 'DATE_COMPONENT') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "CalendarComponent",
                        children: /*#__PURE__*/ jsx(CalendarComponent, {
                            markerComponentProps: m?.markerComponentProps,
                            isLastMessage: isLastMessage
                        })
                    })
                }, `chat-msg-block-input-marker-${i}`);
                if (m?.displayComponentName === 'BLOCK_INPUT_MARKER') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(BlockingInputComponent, {
                        setIsDisablingInputValue: setIsDisablingInputValue
                    })
                }, `chat-msg-block-input-marker-${i}`);
                if (m?.displayComponentName === 'PROMPT_TRIP_PROTECTION') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "TripProtectionMarker",
                        children: /*#__PURE__*/ jsx(TripProtectionMarker, {})
                    })
                }, `chat-msg-trip-protection-marker-${i}`);
                if (m?.displayComponentName === 'DISPLAY_MY_TRIPS') {
                    const { tripsList: trips, hasMoreTrips, deepLinkPrompt, tripHeaderMsg } = m?.markerComponentProps || {};
                    return /*#__PURE__*/ jsx(react.Fragment, {
                        children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                            compnentName: "Trips",
                            children: /*#__PURE__*/ jsx(Trips, {
                                trips: trips,
                                deepLinkPrompt: deepLinkPrompt,
                                tripHeaderMsg: tripHeaderMsg,
                                hasMoreTrips: hasMoreTrips,
                                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent
                            })
                        })
                    }, `chat-msg-display-my-trips-marker-${i}`);
                }
                if (m?.displayComponentName === 'SHOW_SIGNED_OUT_ACTION_BUTTONS') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "SignOutActions",
                        children: /*#__PURE__*/ jsx(SignOutActions, {
                            message: m,
                            submitMessagesFn: submitMessages,
                            ...m?.markerComponentProps || {}
                        })
                    })
                }, `chat-msg-signed-out-actions-marker${i}`);
                if (m?.displayComponentName === 'DISPLAY_FEEDBACK_MARKERS') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "DisplayFeedbackMarker",
                        children: /*#__PURE__*/ jsx(DisplayFeedbackMarker, {
                            msg: m,
                            ...m.markerComponentProps
                        })
                    })
                }, `chat-msg-display-feedback-marker${i}`);
                if (m?.displayComponentName === 'SHOW_CANCEL_CONSEQUENCES_MARKER') return /*#__PURE__*/ jsx(react.Fragment, {
                    children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                        compnentName: "ShowCancelConsequencesMarker",
                        children: /*#__PURE__*/ jsx(ShowCancelConsequencesMarker, {
                            message: m,
                            cancelConsequences: {
                                ...m?.markerComponentProps || {}
                            }
                        })
                    })
                }, `chat-msg-show_cancel_consequences_marker${i}`);
            }),
            isStandalone ? /*#__PURE__*/ jsx("div", {
                ref: messagesEndRef,
                style: {
                    height: 0
                }
            }) : /*#__PURE__*/ jsx(Fragment, {})
        ]
    });
};
ChatMessagesList.displayName = 'ChatMessagesList';
export { ChatMessagesList };
